import { Navigate } from 'react-router-dom'

import { hasWarehouseDevice } from '@/shared/auth/warehouseDeviceStorage'
import { hasWarehouseSession } from '@/shared/auth/warehouseSessionStorage'
import { useClientHydrated } from '@/shared/hooks/useClientHydrated'

export function WarehouseEntryRedirect() {
  const hydrated = useClientHydrated()

  if (!hydrated) {
    return (
      <div className="min-h-[200px] flex items-center justify-center" aria-busy>
        <span className="material-symbols-outlined text-primary text-3xl animate-spin">progress_activity</span>
      </div>
    )
  }
  if (!hasWarehouseDevice()) return <Navigate to="/warehouse/activate" replace />
  if (hasWarehouseSession()) return <Navigate to="/warehouse/home" replace />
  return <Navigate to="/warehouse/login" replace />
}
